export const ACTIVITIES_LIST = [
    {
        name: 'DRAG_AND_DROP_NEEDS_WANTS',
        path: '/student-dashboard/activities/needs-wants'
    },
    {
        name: 'BUDGET',
        path: '/student-dashboard/activities/budgets'
    },
    {
        name: 'STOCK_TRADING',
        path: '/student-dashboard/activities/stock'
    },
    {
        name: 'W4_PDF',
        path: '/student-dashboard/activities/w4-pdf'
    },
    {
        name: 'CAREERS',
        path: '/student-dashboard/activities/careers'
    },
    {
        name: 'INSURANCE',
        path: '/student-dashboard/activities/insurance'
    },
    {
        name: 'REAL_ESTATE_INVESTMENT',
        path: '/student-dashboard/activities/real-estate-investing'
    },
    {
        name: 'REAL_ESTATE_CHECK_STATEMENT',
        path: '/student-dashboard/activities/mortgage-statement'
    },
    {
        name: 'REAL_ESTATE_MORTGAGE',
        path: '/student-dashboard/activities/mortgage-statement-pay'
    },
    {
        name: 'CREDIT_CARD_STATEMENT',
        path: '/student-dashboard/activities/credit-card'
    },
    {
        name: 'CREDIT_CARD_STATEMENT_PAY',
        path: '/student-dashboard/activities/credit-card-payments'
    },
    {
        name: 'CREDIT_CARD_PAY_FUEL',
        path: '/student-dashboard/activities/credit-card-payments'
    },
    {
        name: 'CREDIT_CARD_PAY_RECEIPT',
        path: '/student-dashboard/activities/credit-card-payments'
    },
    {
        name: 'CREDIT_CARD_PAY_CAR',
        path: '/student-dashboard/activities/credit-card-payments'
    },
    {
        name: 'INSURANCE_STATEMENT',
        path: '/student-dashboard/activities/insurance'
    },
    {
        name: 'INSURANCE_DOCTOR_VISIT',
        path: '/student-dashboard/activities/credit-card-payments'
    },
    {
        name: 'EARNING_STATEMENT',
        path: '/student-dashboard/activities/careers'
    },
    {
        name: 'TAX_SIMULATION_PDF',
        path: '/student-dashboard/activities/tax-simulation-pdf'
    },
    {
        name: 'TAX_PAYMENT',
        path: '/student-dashboard/activities/credit-card-payments'
    }
];
